<template>
  <div v-if="data">
    <div>
      <span style="font-size: smaller;">
        {{ data }}
      </span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'AllocationDateCell',
  props: {
    data: {
      type: [String, Date],
      required: false,
      default: null,
    },
  },
}
</script>
